import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Icon } from 'js/components';
import { faPlug, faSpiderWeb } from '@fortawesome/pro-light-svg-icons';

const VARIANTS = {
  notFound: {
    icon: faPlug,
    title: 'Connector not found.',
    linkTo: (team) => `/w/${team.workspace_id}/teams/${team.id}/dashboard`,
    linkLabel: 'Back to Activity',
  },
  notConfigured: {
    icon: faSpiderWeb,
    title: 'This connector is not configured for this team.',
    linkTo: (team) => `/w/${team.workspace_id}/teams/${team.id}/settings`,
    linkLabel: 'Go to Settings',
  },
};

/**
 * Shared empty state for connector tab: "connector not found" or "not configured".
 * Uses media format (Icon + copy + link) for consistency.
 */
function ConnectorTabEmptyState({ team, variant = 'notConfigured' }) {
  const config = VARIANTS[variant] || VARIANTS.notConfigured;
  if (!team) return null;

  return (
    <Card>
      <CardBody>
        <div className="media text-muted mt-4 mb-4">
          <Icon icon={config.icon} size="4x" className="mr-3" fixedWidth />
          <div className="media-body">
            <p>{config.title}</p>
            <p>
              <Link to={config.linkTo(team)}>{config.linkLabel}</Link>
            </p>
          </div>
        </div>
      </CardBody>
    </Card>
  );
}

export default ConnectorTabEmptyState;
